import { NodeDetailsComponent } from "./components/node-details/node-details.component";
import { NodeMainPanelComponent } from "./components/node-main-panel/node-main-panel.component";
import { NodeParentListComponent } from "./components/node-parent-list/node-parent-list.component";
import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { RouteGuard } from "src/app/core/route-guards/route-guard.guard";
import { NodeListComponent } from "./components/node-list/node-list.component";
import { UserRoleNames } from "src/app/core/models/users";
import { NodeNetworkComponent } from "./components/node-network/node-network.component";
import { AllNodesListComponent } from "./components/all-nodes-list/all-nodes-list.component";
import { NodeGpuComponent } from "./components/node-gpu/node-gpu.component";
import { PodInfoComponent } from "./components/pod-info/pod-info.component";
import { ActionLogsComponent } from "../shared/components/actionlogs-component/action-logs.component";

const routes: Routes = [
  {
    path: "Nodes List",
    component: NodeParentListComponent,
    canActivate: [RouteGuard],
    data: {
      role: [
        UserRoleNames.GlobalAdmin,
        UserRoleNames.PowerUser,
        UserRoleNames.DeploymentAdmin,
        UserRoleNames.JobOperator,
      ],
    },
  },
  {
    path: "Nodes List/:cloudType/:deploymentName",
    component: NodeMainPanelComponent,
    canActivateChild: [RouteGuard],
    data: {
      role: [
        UserRoleNames.GlobalAdmin,
        UserRoleNames.PowerUser,
        UserRoleNames.DeploymentAdmin,
        UserRoleNames.JobOperator,
      ],
    },
    children: [
      {
        path: "Nodes",
        component: NodeListComponent,
        children: [
          { path: ":nodeName/Details", component: NodeDetailsComponent },
        ],
      },
      {
        path: "Pods",
        component: PodInfoComponent,
      },
      {
        path: "Pods/:jobName",
        component: PodInfoComponent,
      },
      {
        path: "Node",
        component: AllNodesListComponent,
        children: [
          { path: ":nodeName/Details", component: NodeDetailsComponent },
          { path: ":nodeName/Network", component: NodeNetworkComponent },
          { path: ":nodeName/GPU", component: NodeGpuComponent },
        ],
      },
      {
        path: "Logs",
        component: ActionLogsComponent,
      },
      { path: "", pathMatch: "full", redirectTo: "Nodes" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class NodeRoutingModule {}
